import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import type { App } from 'vue';

export const store = createPinia();
store.use(piniaPluginPersistedstate);

// 전역 플래그를 사용하여 pinia가 이미 설치되었는지 확인
declare global {
  interface Window {
    _piniaInstalled?: boolean;
  }
}

export default function (app: App) {
  // console.log('src/plugins/pinia');
  
  // 이미 Pinia가 설치되었는지 확인
  if (window._piniaInstalled) {
    // console.log('Pinia already installed, skipping');
    return;
  }
  
  // Pinia 설치
  try {
    app.use(store);
    window._piniaInstalled = true;
    // console.log('Pinia successfully installed');
  } catch (error) {
    console.error('Error installing Pinia:', error);
  }
}
